<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <div v-if="Object.keys(validation_errors).length !== 0" class="alert alert-danger alert-dismissible fade show" role="alert">
                        <span v-for="(err, index) in validation_errors" :key="index">
                          {{ err[0] }} <br/>
                        </span>
                    </div>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label class="col-form-label col-form-label-sm" for="batch_id">Select Batch <span style="color: red">*</span></label>
                                <select id="batch_id" v-model="search_data.batch_id"
                                        v-validate="'required'" class="form-control form-control-sm" name="batch_id">
                                    <option value="">Select Batch</option>
                                    <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                                        {{batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Batch
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
                    </form>
                </b-card>

                <b-card>
                    <table class="table table-centered table-striped">
                        <thead>
                        <tr>
                            <th>Sl</th>
                            <th>Title</th>
                            <th>Batch</th>
                            <th>Date</th>
                            <th>Description</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(exam, index) in exams" :key="index">
                            <td>{{ index + 1}}</td>
                            <td>{{ exam.title }}</td>
                            <td>{{ exam.batch ? exam.batch.trade.desc : '' }} | Batch No. : {{ exam.batch ? exam.batch.batch_no : '' }}</td>
                            <td>{{ exam.date }}</td>
                            <td>{{ exam.description }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <h5 v-if="exams.length === 0" class="text-center text-secondary">
                        No Data Found
                    </h5>
                </b-card>
            </div>
        </div>
      <update
          :exam="exam"
          @search="search">
      </update>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import moment from "moment";

    import update from "./modal/update";


    export default {
        page: {
            title: "List Trainee Exam",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, update},
        data() {
            return {
                title: "Search Trainee Exam",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "List",
                        active: true
                    }
                ],
              exam: {},
              exams: {},
                search_data: {
                  batch_id: ''
                },
                batches: [],
                validation_errors: {},
            };
        },

        mounted() {
            this.getBatches();
        },

        methods: {
            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/exam/search", this.search_data)
                            .then(response => {
                                if (!response.error) {
                                    this.exams = response.data.exams;
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                            });
                    }
                });
            },
            getBatches() {
              http.get("api/exam/codes").then(response => {
                if (!response.error) {
                  this.batches = response.data.batches;
                }
              });
            },
            onDelete(id, index) {
              if (confirm("Do you really want to delete?")) {
                http.delete("api/exams/" + id).then(response => {
                  if(response.data.error == true){
                    this.$bvToast.toast(response.data.message, {
                      title: "Error",
                      autoHideDelay: 5000,
                      variant: "danger"
                    });
                  }else{
                    this.exams.splice(index, 1);
                    this.$bvToast.toast(response.data.message, {
                      title: "Success",
                      autoHideDelay: 5000,
                      variant: "success"
                    });
                  }
                });
              }
            },
            async edit(id) {
              this.exam = {}
              await http.get('api/exams/' + id + '/edit').then(response => {
                if (!response.data.error) {
                  this.exam = response.data.exam
                }
              })
            },
            resetForm() {
              this.exam = {}
            },
        }
    };
</script>
